// react
import React, { useState, useEffect, useContext} from 'react';
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import ReactTable from "react-table";
import moment from "moment";
import Datetime from "react-datetime";
import CsvDownloader from 'react-csv-downloader';


// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";
import Edit from "@material-ui/icons/Edit";

// @material-ui components
import Tooltip from "@material-ui/core/Tooltip";

// core components
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { GerenciaModal } from "beaktShared/views/Crud/ModalDetail";
import { GerenciaAlertDelete } from "beaktShared/views/Crud/AlertDelete";
import CreditoDebitoForm from "./CreditoDebitoForm";

// services
import { MaskDate, formateDate, convertDate, validateDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UsePostApi, UseDeleteApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { formateDateandTime } from 'beaktShared/helpers/masks';
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function CreditoDebito() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onChange"});

    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
    
    const endPoint = 'creditosDebitos/';  

    const [item, setItem] = useState({});
    
    useEffect(() => {

        let dtini = Date.now();
        let dtend = moment(dtini); 
        dtend.add(1, 'months');

        dtini = moment(dtini).toDate();
        dtend = dtend.toDate();
        let obj = {
            dataIni:dtini,
            dataFim:dtend
        }
        loadList(obj);
    }, []);
    

    const updateFilds = (obj) =>{
        let dte = formateDate(obj.dataIni);
        let dte2 = formateDate(obj.dataFim);
        setdtini(dte);
        setdtfim(dte2);
    }

    const getEndPoint = () => {
        let endPointGet = "";
        endPointGet =  endPoint +"byfranquia/"+ session.franquiaId;
        return  endPointGet;
    }


    const [dtini, setdtini] = React.useState('');
    const [dtfim, setdtfim] = React.useState('');
    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const loadList = (obj) =>{
        
        if(!obj)
        {
            var dataIniConvertida = convertDate(dtini);
            var dataFimConvertida = convertDate(dtfim);
            obj = {
                dataIni:dataIniConvertida,
                dataFim:dataFimConvertida
            }
        }

        if(obj)
            updateFilds(obj);          

        setisLoadingList(true);       
        const endPoint = getEndPoint();
        setloadingTable(true);
        UsePostApi(endPoint,obj).then(result=>{    
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }    
            setlist(result.data);
            setisLoadingList(false);
            setloadingTable(false); 
            loadDataCsv(result.data);

            
            var dt1 =  formateDate(obj.dataIni);        
            setValue('dtini', dt1); 
            var dt2 =  formateDate(obj.dataFim);        
            setValue('dtfim', dt2); 

            return true;                
        });  
    }

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }
    const handleClickPesquisa = () =>{
        let data = getValues();
        
        if(data.dtini === "")
        {
            setError("dtini","required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")
        
        if(data.dtfim === "")
        {
            setError("dtfim","required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")
        
        if (!validateDate(data.dtini)) {
            setError("dtini", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtini")
        
        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")
        
        var dataIniConvertida = convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);
        
        if(monthDiff(dataIniConvertida,dataFimConvertida) > 3){            
            showNotification(t('error_message.select_3month'), 'danger')
            return false; 
        }        

        let obj = {
            dataIni:dataIniConvertida,
            dataFim:dataFimConvertida
        }
        loadList(obj);
    };

    const [showFormView, setshowFormView] = React.useState(false);
    const handleView = (resetItem) => {    
        if(resetItem)
            setItem({});
        let show = showFormView === true ? false : true;
        setshowFormView(show);        
        
        if(dtini)
            setValue('dtini', formateDate(dtini));             
        if(dtfim)
            setValue('dtfim', formateDate(dtfim));

    };

    const [detailModal, setConfModal] = GerenciaModal();
    const handleDetail = row => {  
        let dataCadastro =  formateDateandTime(row.dataCadastro);
        let dataVencimento =  formateDate(row.dataVencimento);
        let valor = transformValueFloattoFormated(row.valor);
        const bodyDetail=(
        <div>            
            <p><b>{t('label.establishment')}:</b> {row.estabelecimento.descricao}</p>
            <p><b>{t('sale.type')}:</b> {row.tipo === 'D' ? t('label.debit') : t('label.credit')}</p>
            <p><b>{t('label.due_date')}:</b> {dataVencimento}</p>
            <p><b>{t('label.value')}:</b> {valor}</p>
            <p><b>{t('label.historic')}:</b> {row.historico}</p>
            <p><b>{t('royaltie.is_it_in_closing')}: </b>{row.royaltiesId ? t('label.yes') : t('label.not')} </p>
            <p><b>{t('label.date_register')}:</b> {dataCadastro}</p>
        </div>);

        setConfModal({
            showmodal: true,
            dataShow: bodyDetail
          });
    };

    const handleEdit = row => {       
        setItem(row);
        handleView(false);
    };

    const handleAdd = (message) =>{
        showNotification(message,'success');
        handleView(true);
        loadList("");
    }

    const [alertDelete, setAlertDelete] = GerenciaAlertDelete();
    const handleDelete = id =>{
        var userDeletadoId = session.id;
        
        UseDeleteApi(endPoint,id,userDeletadoId).then(result=>{          
            if(result.status !== 200)
            {                                    
                setAlertDelete({statusAlert:2});
                showNotification(result.message,'danger');
                return false; 
            } 

            var listFiltered = list.filter(obj => {
                return obj.creditoDebitoId !== id;
            });
            setlist(listFiltered);                
            setAlertDelete({statusAlert:3}); 
            return true;
        });         
    };
    const showAlertDelete = id =>{
        setAlertDelete({
            statusAlert:1,
            idToDeleteRecieve:id
        }); 
    }  
    useEffect(() => {  
        if(alertDelete.isToDelete)
            handleDelete(alertDelete.idToDeleteSend);      
    // eslint-disable-next-line     
    }, [alertDelete]);

    // *******************************************************************************
    // ********************************** CABEÇALHO CSV **********************************
    // *******************************************************************************

    const columnsCSV = [
        { displayName: "Estabelecimento", id: "estabelecimento" },
        { displayName: "Status", id: "ativo" },
        { displayName: "Tipo", id: "tipo" },
        { displayName: "DataVencimento", id: "dataVencimento" },
        { displayName: "Valor", id: "valor" },
        { displayName: "Historico", id: "historico" },
        { displayName: "Fechamento", id: "fechamento" }
    ];

    // *******************************************************************************
    // ************************** CARREGAR ITENS DO CSV ******************************
    // *******************************************************************************
     
    const [dataCSV,setdataCSV] = React.useState([]);  
    const [loadingTable,setloadingTable] = React.useState(false);
    
    const loadDataCsv = (data) =>{
        let dtCsv = [];

        data.map(item =>{
            var obj = {
                estabelecimento: item.estabelecimento.descricao,
                ativo: item.estabelecimento.ativo == true ? t('label.active') : t('label.inactive'),
                tipo: item.tipo == "D" ? t('label.debit') : t('label.credit'),
                dataVencimento: formateDate(item.dataVencimento),
                valor: "R$ " + item.valor.toFixed(2).replace('.',','),
                historico: item.historico.replaceAll('\n',''),
                fechamento: item.royaltieId ? t('label.yes') : t('label.not')
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    } 

    const columnsProp = [{
        Header: t('label.establishment'),
        accessor: "estabelecimento.descricao"
    },
    {
        Header: 'Status Estabelecimento',
        accessor: "estabelecimento.ativo",
        Cell: (props)=> <span>  {props.value === true ? t('label.active') : t('label.inactive')} </span>
    },
    {
        Header: t('sale.type'),
        accessor: "tipo",
        Cell: (props)=> <span>  {props.value === 'D' ? t('label.debit') : t('label.credit')} </span>,
        filterable: false
    },
    {
        Header: t('label.due_date'),
        accessor: "dataVencimento",
        Cell : (props)=>{
            const custom_date =  formateDate(props.value);
            return <span>{custom_date}</span>
        }
    },
    {
        Header: t('label.value'),
        accessor: "valor",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value)} </div>  
    },
    {
        Header: t('label.historic'),
        accessor: "historico"
    },
    {
        Header: t('royaltie.closing'),
        accessor: "royaltieId",
        Cell: (props)=> <span>  {props.value ? t('label.yes') : t('label.not')} </span>,
        filterable: false
    }]
    const columnsAcao = [        
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">                        
                <Button
                    justIcon
                    round
                    simple                            
                    color="info"
                    className="info"
                    onClick={() => handleDetail(row.original)}
                >
                <Tooltip title={t('label.detail')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Search />
                </Tooltip>
                </Button>{" "}
                <Button
                    justIcon
                    round
                    simple
                    color="success"
                    className="edit"
                    onClick={() => handleEdit(row.original)}
                >
                <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Edit />
                </Tooltip>
                </Button>
                {" "}
                <Button
                    justIcon
                    round
                    simple
                    color="danger"
                    className="remove"
                    onClick={() => showAlertDelete(row.original.creditoDebitoId)} 
                >
                <Tooltip title={t('button.delete')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Close />
                </Tooltip>
                </Button>
            </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp,...columnsAcao]

    const classes = useStyles();
    return (
        <div>

            {notification.show &&
           <Snackbar
           place="tr"
           color={notification.color}
           message={notification.message}
           open={notification.show}
           closeNotification={() => setNotification(false)}
           close
           />}

            {showFormView && 
                <CreditoDebitoForm addItem={handleAdd} item={item} handleView={handleView}  />} 
            
            {!showFormView &&
                <GridContainer>            
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('royaltie.list_of_credits_and_debits')}</h4>
                        </CardHeader>
                        <CardBody>

                            <GridContainer>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>                                                               
                                    <label className={errors.dtini?"select__label select__label_error":"select__label"}>
                                        {t('label.ini_date')+" *"}  </label>
                                    <Datetime                                    
                                        locale={getLocale()}
                                        dateFormat={getStringFormatDate()}
                                        timeFormat={false}                                    
                                        name="dtini"                                      
                                        defaultValue={dtini}
                                        value={dtini}
                                        onChange={date => { setdtini(date) }}
                                        inputProps={{name:"dtini", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                        className={errors.dtini?"error":""}            
                                    />       
                                    {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                        <span> {t('label.required')} </span>                                                                          
                                    </FormHelperText>} 
                                    </FormControl>                                 
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>                                                               
                                    <label className={errors.dtfim?"select__label select__label_error":"select__label"}>
                                        {t('label.end_date')+" *"}  </label>
                                    <Datetime                                    
                                        locale={getLocale()}
                                        dateFormat={getStringFormatDate()}
                                        timeFormat={false}                                    
                                        name="dtfim"                                      
                                        defaultValue={dtfim}
                                        value={dtfim}
                                        onChange={date => { setdtfim(date) }}
                                        inputProps={{name:"dtfim", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                        className={errors.dtfim?"error":""}            
                                    />       
                                    {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                        <span> {t('label.required')} </span>                                                                          
                                    </FormHelperText>} 
                                    </FormControl>                                                                 
                                </GridItem>
                                <GridItem xs={12} sm={6} md={2}>
                                <Button  round color="primary" 
                                    onClick={e => { handleClickPesquisa()}}>
                                    {t('label.search')} 
                                </Button>
                                </GridItem>
                            </GridContainer>
                            <Button
                                color="primary"
                                className={classes.newButton}
                                onClick={() => handleView(true)}
                            >
                               {t('button.new')} 
                            </Button><br></br>
                            <GridContainer>                                                                        
                                <GridItem xs={12} sm={12} md={12}>
                                        
                                   {dataCSV.length > 0 &&

                                        <div>
                                            <div style={{float:'right'}}>
                                            <CsvDownloader
                                            filename="CreditosDebitos"
                                            columns={columnsCSV}
                                            datas={dataCSV}
                                            separator={";"}>
                                                <Button  round color="default" size="sm" >CSV</Button> 
                                            </CsvDownloader>
                                            </div><div style={{clear:'both'}}></div>
                                        </div>
                                    }  
                                </GridItem>            
                            </GridContainer>
                                <ReactTable
                                    loading = {isLoadingList}
                                    data={list}
                                    filterable
                                    defaultFilterMethod = {noCaseSensitive}
                                    columns={columns}
                                    defaultPageSize={10}
                                    minRows={5}
                                    showPaginationBottom={true}
                                    className="-striped -highlight"
                                    previousText={t('button.previous')}
                                    nextText={t('button.next')}
                                    loadingText={t('label.loading')+"..."}
                                    noDataText={t('information_message.no_records_found')+"!"}
                                    pageText={t('label.page')}
                                    ofText={t('label.of')}
                                    rowsText={t('label.rows')}
                                />
                       
                        </CardBody>
                    </Card>
                </GridItem>            
            </GridContainer>
            }  
            
            {alertDelete.componente}
            {detailModal}            
        </div>
    );
}
